module.exports = __webpack_public_path__ + "img/medoro-dark.ead4a5c8.svg";